import {useCompanyFeature} from './useCompanyFeature';
import {tagUsageConstants} from '../../constants';

const USED_VALUES = [tagUsageConstants.MANDATORY, tagUsageConstants.OPTIONAL];

/**
 * Returns whether a `mandatory | optional | not_used` company feature is in use,
 * i.e. the field it controls should be rendered.
 *
 * Use this instead of `useCompanyFeatureAvailable` for tri-state features — the latter
 * only matches a strict `true` and so reports `false` for `'mandatory'` / `'optional'`.
 *
 * @param {string} featureName - The feature key to look up (see `companyFeaturesConstants`).
 * @returns {boolean} `true` when the feature is mandatory or optional, `false` when it is
 * not used or the features are not loaded yet.
 * @example
 * const isTagVisible = useCompanyFeatureUsed(companyFeaturesConstants.INVOICE_TAG_IS_MANDATORY);
 */
export const useCompanyFeatureUsed = (featureName) => {
  const rawValue = useCompanyFeature(featureName);

  // Backward compat: API used to store booleans; true → mandatory, false/null/undefined → not_used.
  // Keep in sync with the equivalent normalizeValue in CompanyFeatureSelect.jsx.
  if (rawValue === true) return true;
  if (!rawValue) return false;

  return USED_VALUES.includes(rawValue);
};
